// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ReceiptDiscountIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "ReceiptDiscount/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.833 1.667H5C2.5 1.667 1.667 3.158 1.667 5v12.5A.83.83 0 0 0 3 18.167L4.425 17.1a.84.84 0 0 1 1.1.083l1.383 1.392a.84.84 0 0 0 1.184 0l1.4-1.4a.826.826 0 0 1 1.083-.075L12 18.167a.835.835 0 0 0 1.333-.667V3.333c0-.916.75-1.666 1.667-1.666H5.833Zm-.358 5.025c.458 0 .833.375.833.833a.836.836 0 0 1-.833.833.836.836 0 0 1-.833-.833c0-.458.375-.833.833-.833Zm4.05 5.041a.83.83 0 0 1-.833-.833c0-.458.375-.833.833-.833.458 0 .833.375.833.833a.836.836 0 0 1-.833.833Zm.692-4.4-4.55 4.55a.618.618 0 0 1-.442.184.618.618 0 0 1-.442-.184.629.629 0 0 1 0-.883l4.55-4.55a.629.629 0 0 1 .884 0 .629.629 0 0 1 0 .883Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.008 1.667v1.25c.55 0 1.075.225 1.459.6.4.408.616.933.616 1.483v2.017c0 .616-.275.9-.9.9h-1.6V3.342c0-.234.192-.425.425-.425v-1.25Zm0 0c-.925 0-1.675.75-1.675 1.675v5.825h2.85c1.317 0 2.15-.834 2.15-2.15V5c0-.917-.375-1.75-.975-2.358a3.37 3.37 0 0 0-2.35-.975c.009 0 0 0 0 0Z"
}));
export default ReceiptDiscountIcon;